"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressBookListItem = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("@reach/router");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const feedbackContext_1 = require("../../../contexts/feedbackContext");
const constants_1 = require("../../../constants");
const AddressBook_1 = require("./AddressBook");
const AddressForm_1 = require("./AddressForm");
const CustomerAccount_1 = require("../../CustomerAccount");
const AddressBookListItem = ({ customerAddress }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const { addAlert } = (0, react_1.useContext)(feedbackContext_1.FeedbackContext);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { localizePath, currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const [defaultShippingBillingText, setDefaultShippingBillingText] = (0, react_1.useState)();
    const [deleteAddressErrorMessage, setDeleteAddressErrorMessage] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (customerAddress.default_shipping && customerAddress.default_billing) {
            setDefaultShippingBillingText(t("customerAccount.addressBook.addressListItem.defaultShippingAndBilling"));
        }
        else if (customerAddress.default_shipping) {
            setDefaultShippingBillingText(t("customerAccount.addressBook.addressListItem.defaultShipping"));
        }
        else if (customerAddress.default_billing) {
            setDefaultShippingBillingText(t("customerAccount.addressBook.addressListItem.defaultBilling"));
        }
        else {
            setDefaultShippingBillingText(undefined);
        }
    }, [customerAddress.default_shipping, customerAddress.default_billing]);
    const handleEdit = () => {
        (0, router_1.navigate)(localizePath(`${CustomerAccount_1.CUSTOMER_ACCOUNT_PATH}${AddressBook_1.ADDRESS_BOOK_PATH}${AddressForm_1.EDIT_ADDRESS_FORM_PATH}`) + `?id=${customerAddress.id}`);
    };
    const handleDelete = () => {
        customerAccountContext.actions.addresses
            .removeAddress({ id: customerAddress.id })
            .then(() => {
            setDeleteAddressErrorMessage(undefined);
            addAlert({ message: t("global.success.deleteAddress"), status: "success" });
        })
            .catch((error) => {
            setDeleteAddressErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
        });
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-item" },
        defaultShippingBillingText && (react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-item-header" },
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-default-shipping-billing" }, defaultShippingBillingText))),
        react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-item-infos" },
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-fullname" },
                customerAddress.firstname,
                " ",
                customerAddress.lastname),
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-street" }, customerAddress.street[0]),
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-city-region-postcode" },
                customerAddress.city,
                ", ", (_a = customerAddress.region.region_code) !== null && _a !== void 0 ? _a : customerAddress.region.region,
                ", ",
                customerAddress.postcode),
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-country" }, customerAddress.country_code),
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-telephone" }, customerAddress.telephone),
            react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-item-delete-address-error-message" }, deleteAddressErrorMessage),
            react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-item-actions" },
                react_1.default.createElement("a", { className: "boutik-customer-account-address-book-list-item-edit", onClick: handleEdit }, t("global.button.edit")),
                !defaultShippingBillingText && (react_1.default.createElement("a", { className: "boutik-customer-account-address-book-list-item-delete", onClick: handleDelete }, t("global.button.delete")))))));
};
exports.AddressBookListItem = AddressBookListItem;
//# sourceMappingURL=AddressBookListItem.js.map